import { TopMarketRequestsType } from '../../constants.ts';
import { useMapTopMarketRequestsData } from '../../hooks/useMapTopMarketRequestsData.ts';

import { TopMarketRequestsTable } from './components/TopMarketRequestsTable.tsx';

export const TopMarketRequests = () => {
  const {
    tableData: { top_bundles, top_domains },
  } = useMapTopMarketRequestsData();

  return (
    <>
      <TopMarketRequestsTable type={TopMarketRequestsType.DOMAINS} tableData={top_domains} />
      <TopMarketRequestsTable type={TopMarketRequestsType.BUNDLES} tableData={top_bundles} />
    </>
  );
};
